// extracted by mini-css-extract-plugin
export var brand = "_7d-9";
export var compact = "_7d-6";
export var extraSmall = "_7d-7";
export var icon = "_7d-0";
export var large = "_7d-4";
export var light = "_7d-1";
export var medium = "_7d-5";
export var outline = "_7d-b";
export var primaryDark = "_7d-a";
export var primaryLight = "_7d-8";
export var primaryModern = "_7d-c";
export var success = "_7d-2";
export var successSolid = "_7d-3";